import { Table, Thead, Tr, Th, Tbody, Td, Skeleton } from "@chakra-ui/react"
import { useGetDiscountsOverview } from "BrokerTsLib/src/hooks/useSupervizor"
import { FormSection, FormSectionHeader } from "../../../components/FormSection"
import { TableWrapper } from "../../../components/TableWrapper"
import { formatDateTime } from "BrokerTsLib/src/Utils/formatPrice"
import { Product } from "BrokerTsLib/src/enums"

export const ProductDiscountsOverview = ({ product, name }: { product: Product, name: string }) => {
    const { data, isLoading } = useGetDiscountsOverview(product)

    return <FormSection>
        <FormSectionHeader>{name}</FormSectionHeader>
        <Skeleton isLoaded={!isLoading} height={'100%'} minH={20}>
            <TableWrapper>
                <Table variant='striped' borderRadius='md'>
                    <Thead>
                        <Tr borderBottom='1px solid' borderBottomColor='gray.200'>
                            <Th>Pojišťovna</Th>
                            <Th textAlign='right'>Sleva</Th>
                            <Th textAlign='right'>Min</Th>
                            <Th textAlign='right'>Max</Th>
                            <Th>Kód</Th>
                            <Th textAlign='right'>Platná do</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data?.data.length === 0 ? <Tr><Td colSpan={6} textAlign='center' py={8}>Žádné slevy</Td></Tr>
                            : data?.data.map((group) =>
                                group.items.map((discount, index) => <>
                                    <Tr key={group.insurerId} borderBottom={index === (group.items.length - 1) ? '1px solid' : 'none'} borderBottomColor='gray.200'>
                                        {index === 0 && <Th rowSpan={group.items.length} w={48}>{group.insurerName}</Th>}
                                        <Td w={48} textAlign='right'>{discount.name}</Td>
                                        <Td w={20} textAlign='right'>{discount.minDiscount} {discount.unit}</Td>
                                        <Td w={20} textAlign='right'>{discount.maxDiscount} {discount.unit}</Td>
                                        <Td>{discount.code}</Td>
                                        <Td textAlign='right'>{discount.validTo && formatDateTime(discount.validTo)}</Td>
                                    </Tr>
                                </>)
                            )}
                    </Tbody>
                </Table>
            </TableWrapper>
        </Skeleton>
    </FormSection>
}